import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { fontSize, desktopMinWidth } from '../mixins';


const Button = styled.button`
  width: 100%;
  max-width: 327px;
  background-color: ${({customColor}) => customColor || '#F58A3C'};
  border-radius: 12px;
  border: none;
  padding: 20px 0;
  margin: ${({customMargin}) => customMargin || '24px 0 0'};
  font-weight: 700;
  ${fontSize(16)};
  line-height: 1;
  color: #FFFFFF;
  position: relative;
  z-index: ${({zIndex}) => zIndex || 'initial'};
  opacity: ${({disabled}) => disabled ? '0.5' : '1'};
  transition: background-color .3s;
  
  &:focus {
    outline: none;
  }
  
  ${({customColor,disabled}) => (!customColor && !disabled) && `
    @media screen and (min-width: ${desktopMinWidth}px) {
      &:hover {
        background-color: #F99B57;
      }
    }

    &:active {
      background-color: #EA7825;
    }
  `}
`;

const UIButton = ({
  onClick,
  children,
  customText,
  disabled,
  customColor,
  zIndex,
  customId,
  customMargin,
}) => {
  const { t } = useTranslation();
  const customInner = customText || t('continue');
  const onClickFunc = () => {
    if (disabled) return;
    onClick()
  };

  return (
    <Button
      onClick={onClickFunc}
      disabled={disabled}
      customColor={customColor}
      customMargin={customMargin}
      id={customId || 'continue-button'}
      zIndex={zIndex}
    >
      {children || customInner}
    </Button>
  );
};

export default UIButton;